export default __webpack_public_path__ + "static/media/platinum@3x.d71cf3d3.png";